import React, { useEffect, useState } from 'react';
import GAdventuresApi from '../services/gadventuresApi';

function PopularDestinations() {
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  React.useEffect(() => {
    const fetchTours = async () => {
      try {
        const response = await fetch('https://rest.gadventures.com/tour_dossiers/', {
          headers: {
            'X-Application-Key': process.env.REACT_APP_GADVENTURES_API_KEY
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch tours');
        }

        const data = await response.json();
        const tourPromises = data.results.slice(0, 10).map(tour => 
          fetch(`https://rest.gadventures.com/tour_dossiers/${tour.id}`, {
            headers: {
              'X-Application-Key': process.env.REACT_APP_GADVENTURES_API_KEY
            }
          }).then(res => res.json())
        );

        const tourDetails = await Promise.all(tourPromises);
        const formattedTours = tourDetails.map(tour => ({
          title: tour.name,
          description: tour.description?.substring(0, 100) + '...',
          image: tour.images?.find(img => img.type === "BANNER_DESKTOP")?.image_href || "https://images.unsplash.com/photo-1544085701-4d54e9f41c45",
          duration: `${tour.details?.find(d => d.detail_type.label === "What's Included")?.body?.match(/\d+(?=\s*days)/) || 'N/A'} days`,
          price: tour.price_per_person?.amount || 1299,
          code: tour.code,
          highlights: tour.details?.find(d => d.detail_type.label === "Highlights")?.body || '',
          serviceLevel: tour.categories?.find(c => c.category_type.label === "Service Level")?.name || 'Standard',
          physicalRating: tour.categories?.find(c => c.category_type.label === "Physical Grading")?.name || 'Light',
          tripType: tour.categories?.find(c => c.category_type.label === "Trip Type")?.name || 'Small Group'
        }));
        
        setTours(formattedTours);
      } catch (err) {
        console.error('Error loading tours:', err);
        setError('Failed to load tours');
      } finally {
        setLoading(false);
      }
    };

    fetchTours();
  }, []);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % tours.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(timer);
  }, [tours.length]);

  if (loading) return <div>Loading tours...</div>;
  if (error) return <div>{error}</div>;

  return (
    <section className="py-16 bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-extrabold text-gray-900 text-center mb-8">
          Popular G Adventures Tours
        </h2>
        <p className="text-xl text-gray-600 text-center mb-12">
          Discover our most exciting small group adventures around the world.
        </p>
        <div className="relative">
          <div className="overflow-hidden rounded-lg shadow-xl">
            <div className="flex transition-transform duration-500 ease-in-out" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
              {tours.map((tour, index) => (
                <div key={index} className="w-full flex-shrink-0">
                  <div className="relative h-96">
                    <img src={tour.image} alt={tour.title} className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                      <div className="text-center p-8">
                        <h3 className="text-2xl font-bold text-white mb-2">{tour.title}</h3>
                        <p className="text-lg text-white mb-4">{tour.description}</p>
                        <div className="mt-4 space-y-2">
                          <div className="flex justify-center space-x-2">
                            <span className="text-white bg-blue-600 px-3 py-1 rounded-full text-sm">
                              {tour.duration}
                            </span>
                            <span className="text-white bg-green-600 px-3 py-1 rounded-full text-sm">
                              From ${tour.price}
                            </span>
                          </div>
                          <div className="flex justify-center space-x-2">
                            <span className="text-white bg-purple-600 px-3 py-1 rounded-full text-sm">
                              {tour.serviceLevel}
                            </span>
                            <span className="text-white bg-yellow-600 px-3 py-1 rounded-full text-sm">
                              {tour.physicalRating}
                            </span>
                          </div>
                        </div>
                        <p className="text-sm text-gray-300 mt-4">
                          Tour Code: {tour.code}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="absolute bottom-4 left-0 right-0 flex justify-center">
            {tours.map((_, index) => (
              <button
                key={index}
                className={`h-3 w-3 mx-1 rounded-full ${index === currentIndex ? 'bg-white' : 'bg-gray-300'}`}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </div>
        </div>
        <div className="mt-12 text-center">
          <p className="text-lg text-gray-700 mb-6">
            G Adventures offers immersive small group tours that take you off the beaten path. Experience authentic local culture, meet like-minded travelers, and create memories that last a lifetime.
          </p>
          <p className="text-lg text-gray-700">
            Our expert guides and carefully crafted itineraries ensure you get the most out of every destination. Join us for sustainable, responsible travel that benefits local communities.
          </p>
        </div>
      </div>
    </section>
  );
}

export default PopularDestinations;